import Avatar from 'components/Avatar/Avatar';
import { ReactComponent as EditPenIcon } from 'assets/icons/edit-pen.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';

import './Note.scoped.scss';

const Note: React.FC = () => {
  return (
    <div className="notes-container">
      <h4>Notes</h4>
      <div className="note">
        <div className="user">
          <div className="avatar">
            <Avatar src="https://media.istockphoto.com/photos/portrait-of-handsome-latino-african-man-picture-id1007763808?k=6&m=1007763808&s=612x612&w=0&h=Js1VDBulbaNw_CF7fghP_nhUPCC-DQTqb7Wym1CdTOI=" />
          </div>

          <div className="info-controls">
            <div className="info">
              <h5>Steffan</h5>
              <p>3 hours ago</p>
            </div>

            <div className="controls">
              <EditPenIcon />
              <TrashIcon />
            </div>
          </div>
        </div>

        <div className="text">
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
          invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
          accusam et justo duo dolores et ea rebum.
        </div>
      </div>
    </div>
  );
};

export default Note;
